import tarefaService from '../services/tarefa.service'
import Quill from 'quill'

let userLogado = document.getElementById('usuario-logado').value
let editorAtendimentoQuill = null

const { showToastify, errorDefault } = GLOBAL

const { criarTarefa } = tarefaService()

export default {
	props: ['open', 'notificacaoEvento'],
	emits: ['close'],

	data() {
		return {
			model: {
				descricao: null,
				deadline: null,
			},
			loading: false,
			showDate: false,
			prazoTarget: null,
			qeditor: null,
		}
	},
	watch: {
		open: {
			handler(newVal) {
				if (newVal) {
					this.createEditorCadastrarTarefaQuill()
				}
			},
		},
	},
	computed: {
		isClienteFundacao() {
			if (this.notificacaoEvento) {
				return this.notificacaoEvento?.fundacao_id ? true : false
			}
		},
		clienteAtivoId() {
			if (this.isClienteFundacao) {
				return this.notificacaoEvento?.fundacao_id
			}

			return this.notificacaoEvento?.cliente_pf_id
		},
		nomeCliente() {
			if (this.isClienteFundacao) {
				return this.notificacaoEvento?.nome_fundacao
			}
			return this.notificacaoEvento?.nome_cliente_pf
		},
	},
	methods: {
		isValidDate(data) {
			if (!data) return false

			if (data instanceof Date) {
				return !isNaN(data.getTime())
			}

			return moment(data, 'DD/MM/YYYY', true).isValid()
		},

		limparEditor() {
			if (editorAtendimentoQuill) {
				editorAtendimentoQuill.setContents([])
				this.qeditor = null
			}

			this.model = {
				descricao: null,
				deadline: null,
			}
		},

		async createNovaTarefa() {
			this.loading = true

			const erros = this.validarCampos()

			if (erros.length > 0) {
				showToastify(`❌ ${erros.join(', ')}`)
				this.loading = false
				return
			}

			const payload = this.createPayloadTarefa()

			try {
				await criarTarefa(payload)
				showToastify(`✅ Tarefa criada com sucesso!`)
				this.closeModal()
			} catch (err) {
				errorDefault(err)
			} finally {
				this.loading = false
			}
		},

		validarCampos() {
			const erros = []

			// Validar descrição do Quill
			if (!editorAtendimentoQuill || !editorAtendimentoQuill.getText().trim()) {
				erros.push('Descrição da tarefa é obrigatória')
			}

			// Validar deadline
			if (!this.model.deadline || !this.model.deadline.trim()) {
				erros.push('Prazo final é obrigatório')
			} else if (!this.isValidDate(this.model.deadline)) {
				erros.push('Data do prazo final é inválida')
			}

			return erros
		},

		createEditorCadastrarTarefaQuill() {
			// Aguarda o próximo tick para garantir que o DOM foi renderizado
			this.$nextTick(() => {
				const editorElement = document.getElementById('editor-tarefa')

				// Verifica se o elemento existe antes de criar o editor
				if (!editorElement) {
					console.warn('Elemento #editor-tarefa não encontrado')
					return
				}

				// Verifica se já existe um editor Quill neste elemento
				if (editorAtendimentoQuill) {
					editorAtendimentoQuill = null
				}

				const SizeStyle = Quill.import('attributors/style/size')
				const AlignStyle = Quill.import('attributors/style/align')

				SizeStyle.whitelist = null

				Quill.register(AlignStyle, true)
				Quill.register(SizeStyle, true)

				editorAtendimentoQuill = new Quill('#editor-tarefa', {
					theme: 'snow',
					formats: [
						'bold',
						'italic',
						'underline',
						'strike',
						'size',
						'color',
						'list',
						'bullet',
						'ordered',
						'background',
						'align',
						'header',
						'indent',
					], // Removido 'check' e 'clean' que estão causando erro
					modules: {
						toolbar: [
							[{ header: [1, 2, false] }],
							[{ size: ['small', false, 'large', 'huge'] }],
							['bold', 'italic', 'underline'],
							[{ list: 'ordered' }, { list: 'bullet' }],
							[{ indent: '-1' }, { indent: '+1' }],
							[{ color: [] }, { background: [] }],
							[{ align: [] }],
							['clean'],
						],
					},
				})

				editorAtendimentoQuill.on('text-change', () => {
					this.qeditor = editorAtendimentoQuill.root.innerHTML
				})

				editorAtendimentoQuill.clipboard.addMatcher(
					Node.ELEMENT_NODE,
					(node, delta) => {
						console.log(node)
						return delta
					}
				)

				if (this.qeditor) {
					editorAtendimentoQuill.root.innerHTML = this.qeditor
				}

				const descricaoNotificacao =
					this.notificacaoEvento?.descricao ||
					this.notificacaoEvento?.mensagem ||
					''

				if (descricaoNotificacao) {
					editorAtendimentoQuill.root.innerHTML = descricaoNotificacao
					this.qeditor = descricaoNotificacao
				} else if (this.qeditor) {
					editorAtendimentoQuill.root.innerHTML = this.qeditor
				}
			})
		},

		createPayloadTarefa() {
			const tipoCliente = {
				[this.isClienteFundacao ? 'fundacao' : 'cliente_pf']:
					this.clienteAtivoId,
			}

			const descricaoQuill = editorAtendimentoQuill
				? editorAtendimentoQuill.root.innerHTML
				: this.qeditor || ''

			return {
				...tipoCliente,
				descricao: descricaoQuill,
				usuario_responsavel: [userLogado],
				status: '1',
				deadline: moment(this.model.deadline, 'DD/MM/YYYY').format(
					'YYYY-MM-DD'
				),
			}
		},

		changeCalendarioInput() {
			this.prazoTarget = document.getElementById('prazo-final')
			this.showDate = !this.showDate
		},

		closeModal() {
			this.limparEditor()
			this.$emit('close')
		},
	},
	mounted() {},
	template: /* html */ `
    <Transition>
        <section v-if="open" 
            class="w-[42rem]  
            !h-max
            !p-16 
            rounded-md absolute 
            overflow-hidden 
            z-[9999999999999999999999] 
            top-1/2 right-1/2 
            translate-y-[-50%] 
            translate-x-[50%] 
            transition-all 
            duration-300 
            ease-in-out">
            <header
                class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure relative z-[9999]"
            >
            <h2 class="text-lg font-medium text-white">Nova Tarefa</h2>
                <button
                    type="button"
                    class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10"
                    data-xclose="modal_padrao"
                    @click="closeModal"
                >
                    <svg class="w-32 h-32">
                        <use xlink:href="#icon_close"></use>
                    </svg>
                </button>
            </header>
            <div class="p-24 bg-white h-full relative z-[9999] space-y-24">

                <div class="flex items-center gap-16">
                    <span class="text-headline-2 text-neutral-100">Cliente: </span>
                    <p class="text-paragraph-2 text-neutral-80">{{ nomeCliente }}</p>
                </div>
                <div class="input-label">
                    <q-input
						v-if="false"
                        v-model="model.descricao"
                        :disable="isDisableFieldsEditFormulario"
                        name="descricao" 
                        id="input-descricao-tarefa"
                        class="!w-full"
                        label="Descrição"
                        label-color="neutral-70"
                        type="text" 
                        autocomplete="off"
                        lazy-rules
                        :rules="[ val => !!val|| 'Descrição Obrigatória' ]"
                                    />

					<div id="editor-tarefa" class=" min-h-[4rem] h-max"></div>
                </div>
                <div class="input-label">
                    <q-input
                        v-model="model.deadline"
                        label="Prazo Final"
                        label-color="neutral-70"
                        placeholder="dd/mm/aaaa"
                        class="!w-full"
                        autocomplete="off"
                        mask="##/##/####"
                        lazy-rules
                        :rules="[ val => !!val || 'Prazo obrigatório', val => isValidDate(val) || 'Data inválida' ]"
                        id="prazo-deadline">
                            <template v-slot:append>
                                <q-icon id="prazo-final" name="event" class="cursor-pointer" @click.stop="changeCalendarioInput">
                                </q-icon>
                            </template>
                    </q-input>

                </div>
             

                    <div class="w-max m-auto flex items-center gap-16">
                        <div
						    class="
							col-span-full 
							flex 
							justify-end 
							items-start 
							px-24 
							gap-24">
						<q-btn
                            :disable="loading"
							class="btn h-48 secondary "
                            @click="closeModal">
								Cancelar
						</q-btn>

                       <q-btn
                           :loading="loading"
                           class="btn h-48 primary "
                           @click="createNovaTarefa"
                       >
                           Criar
                       </q-btn>
                    </div>
                </div>
            </div>
        </section>
    </Transition>

		<Teleport to="body" v-if="open">
				<div class="background-deep fixed left-0 top-0 bg-[rgba(0,0,0,0.25)] w-[100vw] h-[100vh] z-[999]"
				
				></div>
                 <q-popup-proxy v-model="showDate" :target="prazoTarget" transition-show="scale" transition-hide="scale" class="z-[999999999999999999999999999]">
                    <q-date v-model="model.deadline" mask="DD/MM/YYYY">
                        <div class="row items-center justify-end">
                            <q-btn @click="changeCalendarioInput" label="Fechar" color="primary" flat />
                        </div>
                    </q-date>
                </q-popup-proxy>
		</Teleport>

    `,
}
